import { t as i } from "./toString.BD2eC2l5.js";
var n = 0;
function u(r) {
  var t = ++n;
  return i(r) + t;
}
export {
  u
};
